module.exports = __webpack_public_path__ + "img/avatar1.ac859818.png";